export const BaseUrl =
  process.env.NODE_ENV === "production"
    ? "https://web-api.eva-3d.com"
    : "https://web-api.eva-3d.com";
